export default [
  'Accounting & Finance',
  'Advertising & Communication',
  'Aerospace & Defence',
  'Arts',
  'Automotive',
  'Banking (Commercial & Retail)',
  'Business Intelligence',
  'Charity & Voluntary',
  'Chemical & Pharmaceutical',
  'Construction & Property',
  'Consulting & Strategy',
  'Design & Architecture',
  'Economics',
  'Education & Training',
  'Energy, Environmental & Agriculture',
  'Engineering or Industrial',
  'Fast Moving Consumer Goods (FMCG)',
  'Health & Medical',
  'Hospitality & Tourism',
  'Insurance',
  'Investment Banking',
  'IT & Telecommunications',
  'Languages',
  'Legal',
  'Logistics & Transport',
  'Manufacturing',
  'Marketing & Sales',
  'Media',
  'Mining & Resources',
  'Public Sector',
  'Publishing & Journalism',
  'Recruitment',
  'Research',
  'Retail',
  'Science & Technology',
  'Sport & Recreation',
  'Uniformed Services',
]
